export const numOfFrames = 1;
export const initialCaptureDelay = 400;
export const captureInterval = 400;
export const timeout = 40000;
